import { Benefit } from "../shared/hooks/useBenefits.types";

export const pickFirstNotNull = (benefit:Benefit, keys: string[]) => {
    return keys.map(key => benefit[key as keyof Benefit]).find(value => value !== null) ?? null;
}